import React, { useEffect } from "react";

export default function Popup({ data, isOpen, onClose }) {
  useEffect(() => {
    const targetDiv = document.body;

    if (targetDiv) {
      targetDiv.style.overflow = isOpen ? "hidden" : "auto";
    }
    return () => {
      if (targetDiv) {
        targetDiv.style.overflow = "auto";
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;
  const activeItem = Array.isArray(data) && data.length > 0 ? data[0] : null;
  if (!activeItem) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="relative w-[90vw] h-[90vh] md:w-[80vw] md:h-[80vh] flex items-center justify-center">
        <div className="w-full h-full flex items-center justify-center">
          <div className="relative inline-block leading-none">
            <button
              type="button"
              onClick={onClose}
              className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 bg-white w-8 h-8 flex items-center justify-center rounded-full shadow-md hover:bg-gray-200 z-20"
              aria-label="Close popup"
            >
              ✕
            </button>
            <a
              href={activeItem.link || undefined}
              target={activeItem.link ? "_blank" : undefined}
              rel={activeItem.link ? "noopener noreferrer" : undefined}
              className="block"
            >
              <img
                src={activeItem.image}
                alt={activeItem.title || "popup-image"}
                className="max-w-[90vw] max-h-[90vh] md:max-w-[80vw] md:max-h-[80vh] w-auto h-auto object-contain"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}